import {
  GET_BAZAAR_ENQUIRY_LIST_REQUEST,
  GET_BAZAAR_ENQUIRY_LIST_SUCCESS,
  GET_BAZAAR_ENQUIRY_LIST_FAILURE,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  data: [],
  error: false,
  success: false,
}

const getBazaarEnquiryListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BAZAAR_ENQUIRY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
      }

    case GET_BAZAAR_ENQUIRY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        success: true,
      }

    case GET_BAZAAR_ENQUIRY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
      }

    default:
      return state
  }
}

export default getBazaarEnquiryListReducer
